import { supabase } from '@/integrations/supabase/client';

interface ShareSessionInput {
  producer_id: string;
  entity_type: string;
  entity_id: string;
  template_key?: string;
  platform?: string;
  caption_length?: string;
}

/**
 * Log a share session for analytics. Non-blocking — failures are silently ignored.
 */
export async function logShareSession(input: ShareSessionInput): Promise<void> {
  try {
    await (supabase as any).from('share_sessions').insert({
      producer_id: input.producer_id,
      entity_type: input.entity_type,
      entity_id: input.entity_id,
      template_key: input.template_key ?? null,
      platform: input.platform ?? null,
      caption_length: input.caption_length ?? null,
    });
  } catch {
    // Non-blocking — analytics failure must not break share flow
  }
}
